import React from 'react';
import { Quote, Star } from 'lucide-react';
import type { Testimonio } from '../types/content';
interface TestimonialCardProps {
  testimonio: Testimonio;
  showInitials?: boolean;
}
function getInitials(name: string): string {
  return name.replace('.', '').split(' ').map(part => part.charAt(0)).join('').toUpperCase().slice(0, 2);
}
export function TestimonialCard({
  testimonio,
  showInitials = true
}: TestimonialCardProps) {
  return <figure className="flex h-full flex-col rounded-2xl border border-black/5 bg-white p-6 shadow-soft sm:p-7" data-id="element-324" data-mp="2z5vyxqedlhux">
      <div className="flex items-center justify-between" data-id="element-325" data-mp="344fn7xgfz5qg">
        <div className="flex gap-1" aria-label="Valoración: 5 de 5 estrellas" data-id="element-326" data-mp="342usa6q7tks2">
          {Array.from({
          length: 5
        }).map((_, index) => <Star key={index} className="h-4 w-4 fill-dorado text-dorado" aria-hidden="true" data-id="element-327" data-mp="19rg1dmlgxfaq" data-mpi={index} />)}
        </div>
        <Quote className="h-6 w-6 text-bordo/20" aria-hidden="true" data-id="element-328" data-mp="1dtksadkj7xto" />
      </div>

      <blockquote className="mt-5 grow text-[0.95rem] leading-relaxed text-tinta sm:text-base" data-id="element-329" data-mp="htco475j1pxj">
        “{testimonio.quote}”
      </blockquote>

      <figcaption className="mt-6 flex items-center gap-3 border-t border-black/5 pt-5" data-id="element-330" data-mp="d0t9d6v3sor5">
        {showInitials && <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-bordo font-display text-sm font-bold text-white" data-id="element-331" data-mp="80oqxbamxjya">
            {getInitials(testimonio.name)}
          </span>}
        <span className="min-w-0" data-id="element-332" data-mp="vsm1kz2cm5xt">
          <span className="block text-sm font-bold text-bordo" data-id="element-333" data-mp="vtndt6v3oyh4">{testimonio.name}</span>
          <span className="block text-xs text-tintasuave" data-id="element-334" data-mp="qspxz0xkcgis">{testimonio.city}</span>
          <span className="block text-xs text-tintasuave" data-id="element-335" data-mp="luoeiew86f6s">{testimonio.role}</span>
        </span>
      </figcaption>
    </figure>;
}